import React, { FC } from "react";
import { IStepTemplate } from "../../../types";
import { Accordions } from "../../../components/step4/Accordions";
import { DetailImages } from "../../../components/step4/DetailImages";

const Template: FC<IStepTemplate> = ({ stepName }) => (
  <>
    <Accordions name={stepName} />
    <DetailImages name={stepName} />
  </>
);

export default Template;
